import {IStandardMetaData} from "../reducers/meta_data_reducer";

export function setClientMetaData(metaData: IStandardMetaData) {
    try {
        // update title
        window.document.title = metaData.title;
        // update meta data
        safelyUpdateMetaTag("og:title", metaData.title, "property");
        safelyUpdateMetaTag("description", metaData.description);
        safelyUpdateMetaTag("og:description", metaData.description, "property");
        if (metaData.canonical) {
            safelyUpdateLinkTag("canonical", metaData.canonical);
            safelyUpdateMetaTag("og:url", metaData.canonical, "property");
        } else {
            safelyRemoveLinkTag("canonical");
            safelyRemoveMetaTag("og:url", "property");
        }
        metaData.prev ? safelyUpdateLinkTag("prev", metaData.prev) : safelyRemoveLinkTag("prev");
        metaData.next ? safelyUpdateLinkTag("next", metaData.next) : safelyRemoveLinkTag("next");
        metaData.robots ? safelyUpdateMetaTag("robots", metaData.robots) : safelyRemoveMetaTag("robots");
        // update og:image
        metaData.ogImage ? safelyUpdateMetaTag("og:image", metaData.ogImage, "property") : safelyRemoveMetaTag("og:image", "property");
        // update twitter meta tags
        safelyUpdateMetaTag("twitter:title", metaData.title, "name");
        safelyUpdateMetaTag("twitter:description", metaData.description, "name");
        metaData.ogImage ? safelyUpdateMetaTag("twitter:image", metaData.ogImage, "name") : safelyRemoveMetaTag("twitter:image", "name");
    } catch {
        // serverSide render
    }
}

function safelyUpdateMetaTag(name: string, text: string, propertyName = "name") {
    // prepare tag
    const searchName = propertyName === "property" ? `'${name}'` : name;
    const oldTag = window.document.querySelector(`meta[${propertyName}=${searchName}]`);
    const newTag = window.document.createElement("meta");
    newTag.setAttribute(propertyName, name);
    newTag.content = text;
    // update/add tag
    if (oldTag && oldTag.parentNode) {
        oldTag.parentNode.replaceChild(newTag, oldTag);
    } else {
        const head = window.document.querySelector("head");
        head && head.appendChild(newTag);
    }
}

function safelyRemoveMetaTag(name: string, propertyName = "name") {
    const searchName = propertyName === "property" ? `'${name}'` : name;
    const oldTag = window.document.querySelector(`meta[${propertyName}=${searchName}]`);
    if (oldTag && oldTag.parentNode) {
        oldTag.parentNode.removeChild(oldTag);
    }
}

function safelyUpdateLinkTag(name: string, text: string) {
    // prepare tag
    const oldTag = window.document.querySelector(`link[rel=${name}]`);
    const newTag = window.document.createElement("link");
    newTag.rel = name;
    newTag.href = text;
    // update/add tag
    if (oldTag && oldTag.parentNode) {
        oldTag.parentNode.replaceChild(newTag, oldTag);
    } else {
        const head = window.document.querySelector("head");
        head && head.appendChild(newTag);
    }
}

function safelyRemoveLinkTag(name: string) {
    const oldTag = window.document.querySelector(`link[rel=${name}]`);
    if (oldTag && oldTag.parentNode) {
        oldTag.parentNode.removeChild(oldTag);
    }
}
import {IStandardMetaData} from "../reducers/meta_data_reducer";

export function setClientMetaData(metaData: IStandardMetaData) {
    try {
        // update title
        window.document.title = metaData.title;
        // update meta data
        safelyUpdateMetaTag("og:title", metaData.title, "property");
        safelyUpdateMetaTag("description", metaData.description);
        safelyUpdateMetaTag("og:description", metaData.description, "property");
        if (metaData.canonical) {
            safelyUpdateLinkTag("canonical", metaData.canonical);
            safelyUpdateMetaTag("og:url", metaData.canonical, "property");
        } else {
            safelyRemoveLinkTag("canonical");
            safelyRemoveMetaTag("og:url", "property");
        }
        metaData.prev ? safelyUpdateLinkTag("prev", metaData.prev) : safelyRemoveLinkTag("prev");
        metaData.next ? safelyUpdateLinkTag("next", metaData.next) : safelyRemoveLinkTag("next");
        metaData.robots ? safelyUpdateMetaTag("robots", metaData.robots) : safelyRemoveMetaTag("robots");
        // update og:image
        metaData.ogImage ? safelyUpdateMetaTag("og:image", metaData.ogImage, "property") : safelyRemoveMetaTag("og:image", "property");
        // update twitter meta tags
        safelyUpdateMetaTag("twitter:title", metaData.title, "name");
        safelyUpdateMetaTag("twitter:description", metaData.description, "name");
        metaData.ogImage ? safelyUpdateMetaTag("twitter:image", metaData.ogImage, "name") : safelyRemoveMetaTag("twitter:image", "name");
    } catch {
        // serverSide render
    }
}

function safelyUpdateMetaTag(name: string, text: string, propertyName = "name") {
    // prepare tag
    const searchName = propertyName === "property" ? `'${name}'` : name;
    const oldTag = window.document.querySelector(`meta[${propertyName}=${searchName}]`);
    const newTag = window.document.createElement("meta");
    newTag.setAttribute(propertyName, name);
    newTag.content = text;
    // update/add tag
    if (oldTag && oldTag.parentNode) {
        oldTag.parentNode.replaceChild(newTag, oldTag);
    } else {
        const head = window.document.querySelector("head");
        head && head.appendChild(newTag);
    }
}

function safelyRemoveMetaTag(name: string, propertyName = "name") {
    const searchName = propertyName === "property" ? `'${name}'` : name;
    const oldTag = window.document.querySelector(`meta[${propertyName}=${searchName}]`);
    if (oldTag && oldTag.parentNode) {
        oldTag.parentNode.removeChild(oldTag);
    }
}

function safelyUpdateLinkTag(name: string, text: string) {
    // prepare tag
    const oldTag = window.document.querySelector(`link[rel=${name}]`);
    const newTag = window.document.createElement("link");
    newTag.rel = name;
    newTag.href = text;
    // update/add tag
    if (oldTag && oldTag.parentNode) {
        oldTag.parentNode.replaceChild(newTag, oldTag);
    } else {
        const head = window.document.querySelector("head");
        head && head.appendChild(newTag);
    }
}

function safelyRemoveLinkTag(name: string) {
    const oldTag = window.document.querySelector(`link[rel=${name}]`);
    if (oldTag && oldTag.parentNode) {
        oldTag.parentNode.removeChild(oldTag);
    }
}
